// extracted by mini-css-extract-plugin
export default {"container":"HowItWorksAdmin_container__1Rzw5","form":"HowItWorksAdmin_form__Y2Zei","list":"HowItWorksAdmin_list__HZeFL"};